//import * as React from 'react';
//import { Header } from '../../../Styles/ScreenStyle';
import {
  Box
} from '@mui/material';
import { useParams } from 'react-router-dom';
import usePedidoAdicionarProduto from '../../../../hooks/usePedidoAdicionarProduto';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import Typography from '@mui/material/Typography';
import { Loader } from '../../../../shared/components/Loader';
import { Input } from '../../../../shared/components/Input';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { InputWeight } from '../../../../shared/components/InputWeight';


export default function AdicionarPedido(){
    
    const { id } = useParams();

    const produtoId = id ? parseInt(id, 10) : null;
  
    const {
      loading,
      handleSubmit,
      errors,
      handleBlur,
      touched,
      handleChange,
      values,
      backActions,
    } = usePedidoAdicionarProduto(produtoId);

    return (
        <Loader loading={loading}>
          <HeaderComponent text={'CADASTRO DE PEDIDO PRODUTO'} />
          <Box className='p-3'>
            <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
              <Box className='grid grid-cols-8 gap-7 pt-4'>
                <Box className='col-span-3'>
                  <HeaderFormActions backActions={() => backActions()} />
                </Box> 
    
                <Typography className='col-span-8' variant='h6'>
                  Dados do Produto
                </Typography>
                <Input
                  label='Produto'
                  className='col-span-4'
                  name='Produto'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Produto && errors.Produto ? errors.Produto : ''}
                  hasError={!!(touched.Produto && errors.Produto)}
                  value={values.Produto}
                />                
                <Input
                  label='Grupo Tributário'
                  className='col-span-4'
                  name='GrupoTributario'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.GrupoTributario && errors.GrupoTributario ? errors.GrupoTributario : ''}
                  hasError={!!(touched.GrupoTributario && errors.GrupoTributario)}
                  value={values.GrupoTributario}
                />                
                <Input
                  label='Armazém'
                  className='col-span-4'
                  name='Armazem'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Armazem && errors.Armazem ? errors.Armazem : ''}
                  hasError={!!(touched.Armazem && errors.Armazem)}
                  value={values.Armazem}
                />
                <Input
                  label='Lote'
                  className='col-span-4'
                  name='Lote'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Lote && errors.Lote ? errors.Lote : ''}
                  hasError={!!(touched.Lote && errors.Lote)}
                  value={values.Lote}
                />                
                <Input
                  label='Quantidade'
                  className='col-span-4'
                  name='Quantidade'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Quantidade && errors.Quantidade ? errors.Quantidade : ''}
                  hasError={!!(touched.Quantidade && errors.Quantidade)}
                  value={values.Quantidade}
                />    
                <Input
                  label='Saldo em Estoque'
                  className='col-span-4'
                  name='SaldoEstoque'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.SaldoEstoque && errors.SaldoEstoque ? errors.SaldoEstoque : ''}
                  hasError={!!(touched.SaldoEstoque && errors.SaldoEstoque)}
                  value={values.SaldoEstoque}
                />          
                <InputMoney
                  label='Valor'
                  className='col-span-4'
                  name='Valor'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Valor && errors.Valor ? errors.Valor : ''}
                  hasError={!!(touched.Valor && errors.Valor)}
                  value={values.Valor}
                />
                <InputMoney
                  label='Desconto'
                  className='col-span-4'
                  name='Desconto'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Desconto && errors.Desconto ? errors.Desconto : ''}
                  hasError={!!(touched.Desconto && errors.Desconto)}
                  value={values.Desconto}
                />
                <Input
                  label='Total'
                  className='col-span-4'
                  name='Total'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.Total && errors.Total ? errors.Total : ''}
                  hasError={!!(touched.Total && errors.Total)}
                  value={values.Total}
                />
                <InputWeight
                  label='Peso Líquido (Kg)'
                  className='col-span-4'
                  name='PesoLiquido'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={
                    touched.PesoLiquido && errors.PesoLiquido ? errors.PesoLiquido : ''}
                  hasError={!!(touched.PesoLiquido && errors.PesoLiquido)}
                  value={values.PesoLiquido}
                />               
                <InputWeight
                  label='Peso Bruto (Kg)'
                  className='col-span-4'
                  name='PesoBruto'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.PesoBruto && errors.PesoBruto ? errors.PesoBruto : ''}
                  hasError={!!(touched.PesoBruto && errors.PesoBruto)}
                  value={values.PesoBruto}
                />
                <InputWeight
                  label='Peso Líquido Total (Kg)'
                  className='col-span-4'
                  name='PesoLiquidoTotal'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.PesoLiquidoTotal && errors.PesoLiquidoTotal ? errors.PesoLiquidoTotal : ''}
                  hasError={!!(touched.PesoLiquidoTotal && errors.PesoLiquidoTotal)}
                  value={values.PesoLiquidoTotal}
                />
                <InputWeight
                  label='Peso Bruto Total (Kg)'
                  className='col-span-4'
                  name='PesoBrutoTotal'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.PesoBrutoTotal && errors.PesoBrutoTotal ? errors.PesoBrutoTotal : ''}
                  hasError={!!(touched.PesoBrutoTotal && errors.PesoBrutoTotal)}
                  value={values.PesoBrutoTotal}
                />                
                <Input
                  label='ICMS Substituto'
                  className='col-span-4'
                  name='ICMS'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.ICMS && errors.ICMS ? errors.ICMS : ''}
                  hasError={!!(touched.ICMS && errors.ICMS)}
                  value={values.ICMS}
                />
                <Input
                  label='Número Pedido Compra'
                  className='col-span-4'
                  name='NumeroPedidoCompra'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.NumeroPedidoCompra && errors.NumeroPedidoCompra ? errors.NumeroPedidoCompra : ''}
                  hasError={!!(touched.NumeroPedidoCompra && errors.NumeroPedidoCompra)}
                  value={values.NumeroPedidoCompra}
                />
                <Input
                  label='Número Item Pedido Compra'
                  className='col-span-4'
                  name='NumeroItemPedidoCompra'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.NumeroItemPedidoCompra && errors.NumeroItemPedidoCompra ? errors.NumeroItemPedidoCompra : ''}
                  hasError={!!(touched.NumeroItemPedidoCompra && errors.NumeroItemPedidoCompra)}
                  value={values.NumeroItemPedidoCompra}
                />
                <Input
                  label='Percentual Redução Base Cálculo'
                  className='col-span-4'
                  name='PercentualReducaoBaseCalc'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.PercentualReducaoBaseCalc && errors.PercentualReducaoBaseCalc ? errors.PercentualReducaoBaseCalc : ''}
                  hasError={!!(touched.PercentualReducaoBaseCalc && errors.PercentualReducaoBaseCalc)}
                  value={values.PercentualReducaoBaseCalc}
                />
                <Input
                  label='Percentual Redução Base Cálculo ST.'
                  className='col-span-4'
                  name='PercentualReducaoBaseCalcST'
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  error={touched.PercentualReducaoBaseCalcST && errors.PercentualReducaoBaseCalcST ? errors.PercentualReducaoBaseCalcST : ''}
                  hasError={!!(touched.PercentualReducaoBaseCalcST && errors.PercentualReducaoBaseCalcST)}
                  value={values.PercentualReducaoBaseCalcST}
                />
              </Box>
            </form>
          </Box>
        </Loader>
      );
}